/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/XVSProxyOFTSrc.json';
import { XVSProxyOFTSrc } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetXVSProxyOFTSrcContractAddressInput {
  chainId: ChainId;
}

export const getXVSProxyOFTSrcContractAddress = ({
  chainId,
}: GetXVSProxyOFTSrcContractAddressInput) =>
  getUniqueContractAddress({ name: 'XVSProxyOFTSrc', chainId });

export const useGetXVSProxyOFTSrcContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getXVSProxyOFTSrcContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetXVSProxyOFTSrcContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getXVSProxyOFTSrcContract = ({
  chainId,
  signerOrProvider,
}: GetXVSProxyOFTSrcContractInput) => {
  const address = getXVSProxyOFTSrcContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as XVSProxyOFTSrc) : undefined;
};

interface UseGetXVSProxyOFTSrcContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetXVSProxyOFTSrcContract = (input?: UseGetXVSProxyOFTSrcContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getXVSProxyOFTSrcContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
